import {bootstrapApplication} from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import {appConfig} from './app/app.config';
import {App} from './app/app';
import {environment} from './environments/environment';

if (environment.production) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.sentryEnvironment,
    release: environment.version,
    tracesSampleRate: 0,
    sendDefaultPii: false,
  });
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
